module.exports = __webpack_public_path__ + "img/autrial.5e4dfb92.webp";